<template>
    <div>
        <div v-if="obj.products.length > 0" class="maintenance-alert">
            <div class="maintenance-alert__glow"></div>
            <div class="maintenance-alert__icon-wrap">
                <i class="fa-light fa-wrench maintenance-alert__icon"></i>
            </div>
            <div class="maintenance-alert__content">
                <span class="maintenance-alert__badge">
                    {{ obj.products.length }} {{ obj.products.length === 1 ? 'Produto' : 'Produtos' }}
                </span>
                <p class="maintenance-alert__title">Atenção, aguardando envio para manutenção</p>
                <p class="maintenance-alert__subtitle">Produtos pré-selecionados prontos para gerar Ordem de Serviço</p>
            </div>
            <div class="maintenance-alert__action">
                <Button _key="btnOpenProducts" type="primary" classIcon="fa-solid fa-list-timeline" title="Abrir Manutenção"
                    size="medium" :clicked="openProducts" />
            </div>
        </div>

        <Modal title="Ordem de Serviço" :width="900" v-show="showModal('maintenance')">
            <div v-if="loading">
                <span>Aguarde, estamos gerando, isso pode levar alguns segundos...</span>
                <Loading type="line" :center="false" />
            </div>
            <div v-else>
                <div v-if="success && !loading">
                    <div class="div-success text-center">
                        <i class="fa-light fa-circle-check icon-success"></i>
                        <div class="msg-success"> Ordem de Serviço Nº{{ os.number }}
                        </div>
                        <br>
                        <div>
                            <Button _key="btnNavegate" title="Ir para ordem de serviço" classIcon="fa-solid fa-link"
                                size="medium" :clicked="navegateTo" />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <b-row>
                        <b-col sm="6">
                            <InputText title="Identificação" field="identification" :required="true" :maxLength="100"
                                v-model="obj.identification" />
                        </b-col>
                        <b-col sm="3">
                            <DateTime title="Inicio" field="startDateHour" format="DD/MM/YYYY" type="date" placeholder
                                :markFormDirty="false" :required="true" v-model="obj.dateStart" />
                        </b-col>
                        <b-col sm="3">
                            <DateTime title="Fim (Previsão)" field="endDateHour" format="DD/MM/YYYY" type="date"
                                placeholder :markFormDirty="false" :required="true" v-model="obj.dateEnd" />
                        </b-col>
                    </b-row>
                    <ScrollBar v-if="obj.products.length > 0" :minHeight="400" :maxHeight="400">
                        <div v-for="product in obj.products">
                            <div class="molded-item">
                                <b-row>
                                    <b-col sm="8">
                                        <span class="title"> {{ product.productFullName }}</span>
                                        <span v-if="product.barCode"> - {{ product.barCode }}</span>
                                        <InputTextEdit v-model="product.description" />
                                    </b-col>
                                    <b-col sm="2">
                                        <IncrementDecrement v-if="!product.patrimonyId" :min="1"
                                            :max="product.quantityMax" v-model="product.quantity" />
                                        <span v-else>
                                            <div class="text-center">
                                                <span class="title"> 1</span>
                                            </div>
                                        </span>
                                    </b-col>
                                    <b-col sm="1">
                                        <div class="icon-remove"
                                            @click="removeItem(product.productId, product.patrimonyId)">
                                            <i class="fas fa-times"></i>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </ScrollBar>
                    <div v-else>Nenhum produto adicionado!</div>
                    <div class="text-center">
                        <Button _key="btnOpenProducts" :disabled="obj.products.length == 0" type="primary"
                             title="Gerar Manutenção" size="large" :clicked="generateOs" />
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import DateTime from "@nixweb/nixloc-ui/src/component/forms/DateTime";
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import InputNumber from "@nixweb/nixloc-ui/src/component/forms/InputNumber";
import IncrementDecrement from "@nixweb/nixloc-ui/src/component/forms/IncrementDecrement.vue";
import InputTextEdit from "@nixweb/nixloc-ui/src/component/forms/InputTextEdit.vue";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
    name: "AddOrRemoveMaintenance",
    props: ["rentId"],
    components: {
        Button, Modal, ScrollBar, DateTime, InputText, InputNumber, IncrementDecrement, InputTextEdit, Molded, Loading
    },
    data() {
        return {
            urlCreate: "/api/v1/maintenance/order-service/create-from-moviment",
            success: false,
            loading: false,
            os: {},
            obj: {
                identification: "",
                dateStart: "",
                dateEnd: "",
                products: [],
            },
        }
    },
    computed: {
        ...mapGetters("generic", ["showModal"]),
        ...mapGetters("generic", ["event"]),
    },
    methods: {
        ...mapMutations("generic", ["openModal", "hideModal", "removeLoading"]),
        ...mapActions("generic", ["postApi"]),
        generateOs() {
            this.loading = true;
            var obj = { ...this.obj, ...{ rentId: this.rentId } }
            let params = { url: this.urlCreate, obj: obj, notNotifyToast: true };
            this.postApi(params).then((response) => {
                if (response.success) {
                    this.success = true;
                    this.os = response.content;
                    let self = this;
                    setTimeout(function () {
                        self.loading = false;
                    }, 2000);
                } else {
                    this.loading = false;
                }

                this.removeLoading(["btnOpenProducts"]);
            });
        },
        addOrRemove(data) {
            if (data.barCode) {
                let obj = this.createPatrimony(data);
                this.addOrRemoveProduct(obj, "patrimony");
            }

            if (data.patrimony.length == 0) {
                let obj = this.createProduct(data);
                this.addOrRemoveProduct(obj, "product");
            }
        },
        createPatrimony(item) {
            var obj = {
                patrimonyId: item.id,
                productId: item.productId,
                productFullName: item.productFullName,
                barCode: item.barCode,
                description: "",
                quantity: 1
            }
            return obj;
        },
        createProduct(item) {
            var obj = {
                patrimonyId: null,
                productId: item.productId,
                productFullName: item.productFullName,
                barCode: null,
                description: "",
                quantity: item.totalSelected,
                quantityMax: item.totalSelected
            }
            return obj;
        },
        addOrRemoveProduct(newProduct, type) {
            var index = 0;

            if (type == "product") {
                index = this.obj.products.findIndex(product => product.productId === newProduct.productId);
            } else {
                index = this.obj.products.findIndex(product => product.patrimonyId === newProduct.patrimonyId);
            }

            if (index !== -1) {
                this.obj.products.splice(index, 1);
            } else {
                this.obj.products.push(newProduct);
            }
        },
        removeItem(productId, patrimonyId) {
            if (patrimonyId != null) {
                this.obj.products = this.obj.products.filter(item => item.patrimonyId !== patrimonyId);
            } else {
                this.obj.products = this.obj.products.filter(item => item.productId !== productId);
            }
        },
        openProducts() {
            this.openModal("maintenance");
            this.removeLoading(["btnOpenProducts"]);
        },
        navegateTo() {
            this.hideModal();
            this.removeLoading(["btnNavegate"]);
            this.$router.push({
                name: "orderServiceUpdate",
                params: { id: this.os.id },
            });
        },
    },
    watch: {
        event: {
            handler(event) {
                if (event.name == "addOrRemoveMaintenance") {
                    let self = this;
                    setTimeout(function () {
                        self.addOrRemove(event.data);
                    }, 100);
                }
            },
            deep: true,
        },
    }
}

</script>

<style scoped>

.maintenance-alert {
    position: relative;
    display: flex;
    align-items: center;
    gap: 16px;
    background: #ffffff;
    border: 1px solid #e8eaed;
    border-left: 4px solid #FF8A1B;
    border-radius: 10px;
    padding: 14px 18px;
    margin-top: 16px;
    margin-bottom: 14px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(52, 73, 94, 0.07);
    animation: slideDown 0.35s ease forwards;
}

@keyframes slideDown {
    from { opacity: 0; transform: translateY(-12px) scale(0.98); }
    to   { opacity: 1; transform: translateY(0)     scale(1);    }
}

.maintenance-alert__glow {
    position: absolute;
    top: -30px;
    right: -30px;
    width: 130px;
    height: 130px;
    background: radial-gradient(circle, rgba(255, 138, 27, 0.10) 0%, transparent 70%);
    pointer-events: none;
}

.maintenance-alert__icon-wrap {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #fff5eb;
    border: 1px solid #ffd5a8;
    animation: iconPulse 1.8s ease-in-out infinite;
}

@keyframes iconPulse {
    0%, 100% {
        box-shadow: 0 0 0 0    rgba(255, 138, 27, 0.45);
        transform: scale(1);
    }
    50% {
        box-shadow: 0 0 0 12px rgba(255, 138, 27, 0);
        transform: scale(1.12);
    }
}

.maintenance-alert__icon {
    font-size: 18px;
    color: #FF8A1B;
    animation: iconBlink 1.8s ease-in-out infinite;
}

@keyframes iconBlink {
    0%, 100% { opacity: 1;    transform: scale(1);    }
    50%       { opacity: 0.5; transform: scale(0.88); }
}

/* Bloco de texto */
.maintenance-alert__content {
    flex: 1;
    min-width: 0;
}

.maintenance-alert__badge {
    display: inline-block;
    background: #fff5eb;
    color: #FF8A1B;
    border: 1px solid #ffd5a8;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    border-radius: 999px;
    padding: 2px 10px;
    margin-bottom: 4px;
}

.maintenance-alert__title {
    margin: 0 0 2px;
    font-size: 14px;
    font-weight: 600;
    color: #2c3345;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.maintenance-alert__subtitle {
    margin: 0;
    font-size: 12px;
    color: #757D8C;
}

.maintenance-alert__action {
    flex-shrink: 0;
}

/* ── Item da lista de produtos ── */
.molded-item {
    border: 1px solid #DBDFE9;
    border-left: 3px solid #FF8A1B;
    background-color: #ffffff;
    border-radius: 8px !important;
    padding: 10px 10px 0;
    margin-bottom: 10px;
    min-height: 70px;
    transition: background 0.15s;
}

.molded-item:hover {
    background: #fffdf8;
}

/* ── Botão remover ── */
.icon-remove {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    width: 100px;
    cursor: pointer;
    color: #FF5454;
    font-size: 16px;
    transition: color 0.2s;
}

.icon-remove:hover {
    color: #cc2222;
}

/* ── Sucesso ── */
.msg-success {
    font-size: 16px;
    color: #2c3345;
    font-weight: 500;
}

.icon-success {
    font-size: 28px;
    margin-bottom: 10px;
    color: #38A169;
}

.div-success {
    padding-top: 30px;
    height: 200px;
}

/* ── Navegar para OS ── */
.title-navegate {
    color: #3f529b;
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
}

.title-navegate:hover {
    text-decoration: underline;
    color: #2c3a7a;
}
</style>